import React from "react";
import moment from "moment-timezone";
import Moment from "react-moment";
import Col from "react-bootstrap/Col";
import { ThreeDots } from "react-loader-spinner";

const LiveTimer = ({
  start,
  isRunning,
  customeTime,
  isOnline,
  stopLoading,
  user,
  selectedUser,
  trigger,
  handleEndClick,
  handleStartClick,
  dateSection = null,
  calendarPortalRef = null,
}) => {
  return (
    <div className="start-timer-outer">
      <Col className="start-timer-inner">
        <div className="start-timer-meta" ref={calendarPortalRef}>
          <Moment
            interval={1000}
            date={moment.tz(start, global.config.getTimeZone())}
            format="hh:mm:ss"
            durationFromNow
            tz={global.config.getTimeZone()}
          />
          {dateSection}
        </div>
        <div className="start-timer-actions">
          {isRunning === true && customeTime === false && isOnline === true && (
            <button
              onClick={handleEndClick}
              className="button-pad-stop"
              type="button"
              disabled={stopLoading || user?._id !== selectedUser || trigger}
            >
              {stopLoading ? (
                <ThreeDots
                  height="18"
                  width="20"
                  radius="9"
                  color="white"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              ) : (
                "Stop"
              )}
            </button>
          )}
          {isRunning === false && customeTime === false && isOnline === true && (
            <button
              onClick={handleStartClick}
              className="button-pad-start"
              type="button"
              disabled={user?._id !== selectedUser}
            >
              Start
            </button>
          )}
        </div>
      </Col>
    </div>
  );
};

export default LiveTimer;
